import Render from "../pages/canvas/paper/render";
import DND from "../pages/canvas/paper/dndhandler";

export default function Column(props) {
  return (
    <div
      ref={props.editorRef}
      style={{
        display: "flex",
        flexDirection: "column",
        position: "relative",
        visibility: props.block.hidden ? "hidden" : "unset",
        flexBasis: 0,
        backgroundColor: props.block.props.backgroundColor,
        justifyContent: props.block.props.justifyContent,
        alignItems: props.block.props.alignItems,
        flexGrow: props.block.props.flexGrow,
        boxShadow: props.block.props.boxShadow,
        ...props.block.props.spacing,
        ...props.block.props.size,
        ...props.block.props.border,
      }}
    >
      {props.children.map((block, index) => {
        const newPath = [...props.path];
        newPath.push(index);

        return (
          <DND
            key={block.id}
            disabled={props.disabled}
            block={block}
            path={newPath}
            index={index}
          >
            <Render />
          </DND>
        );
      })}
    </div>
  );
}
